import { useState } from 'react'
import styled from 'styled-components'
import { Row } from 'styled/alignment/Row'
import Modal from 'components/_UI/Modal'
import Loader from 'components/_UI/Loader'
import Button from 'components/_UI/Button'
import Text from 'components/_UI/Text'
import breakpoints from 'theme/breakpoints'
import buttonText from 'texts/buttons/buttonText'
import productsTemplateApi from 'api/requests/products'
import ticketsApi from 'api/requests/tickets'

export default function DeleteProductModal ({
    isOpen,
    onClose = () => {},
    onSuccess = () => {},
    onError = () => {},
    selectedProduct,
    activeTab,
}) {
    const [loading, setLoading] = useState(false)

    const deleteEndpoints = {
        template: (product) => {
            return productsTemplateApi.delete(product.id)
        },

        establishment: (product) => {
            ticketsApi.deleteBulk({
                data: {
                    productsToDelete: [product.id],
                    batchesToDelete: Array.isArray(product.batches) ? product.batches.filter(batch => batch.id ?? false).map(batch => batch.id) : []
                }
            })
        }
    }

    async function deleteProduct () {
        try {
            setLoading(true)

            await deleteEndpoints[activeTab](selectedProduct)

            onClose()
            onSuccess(selectedProduct)
        } catch (error) {
            setLoading(false)
            onError()
            console.error(error)
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <Text>Tem certeza que deseja excluir esse produto?</Text>

            {
                !loading ? (
                    <ContentConfirm>
                        <ContentButton>
                            <Button
                                variant='secondary'
                                onClick={onClose}
                            >
                                {buttonText.cancel}
                            </Button>
                        </ContentButton>

                        <ContentButton>
                            <Button
                                onClick={deleteProduct}
                            >
                                {buttonText.delete}
                            </Button>
                        </ContentButton>

                    </ContentConfirm>
                ) : (
                    <Loader />
                )
            }
        </Modal>
    )
}

const ContentConfirm = styled.div`
    flex-direction: row;
    display: flex;
    justify-content: center;
    @media screen and (max-width: ${breakpoints.xm}) {
        margin-top: 25px;
        justify-content: space-around;
    }
    @media screen and (min-width: ${breakpoints.sm}) {
        margin-top: 0px;
        justify-content: center;
    }
`;

const ContentButton = styled(Row)`
    @media screen and (max-width: ${breakpoints.xm}) {
        width: 85px;
        padding: 0;
    }
    width: 120px;
    padding: 10px 10px 0 10px;
`